var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "manage-booking" };
var _hoisted_2 = ["disabled"];
import AmadeusFormSubmission from '../AmadeusFormSubmission/AmadeusFormSubmission.vue';
import InputField from '../InputField/InputField.vue';
import { computed, inject, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ManageBooking',
    props: {
        buttontext: {
            type: String,
            default: 'Manage your booking',
        },
    },
    setup: function (__props) {
        var _a, _b;
        var inputErrors = ref({});
        var selectedOption = ref('REC_LOC');
        var bookingNumber = ref('');
        var DIRECT_RETRIEVE_LASTNAME = ref('');
        var updateSelectedOption = function (option) {
            if (option !== selectedOption.value) {
                selectedOption.value = option;
                bookingNumber.value = '';
            }
            inputErrors.value = {};
        };
        var handleSubmit = function (event) {
            if (selectedOption.value === 'REC_LOC' && bookingNumber.value.length !== 6) {
                inputErrors.value = {
                    REC_LOC: 'Booking reference number must be 6 characters.',
                };
                event.preventDefault();
            }
            else if (selectedOption.value === 'E_TICKET_NUMBER' &&
                bookingNumber.value.length !== 14) {
                inputErrors.value = {
                    E_TICKET_NUMBER: 'E-ticket number must be 14 characters.',
                };
                event.preventDefault();
            }
        };
        var refxManageBookingUrl = inject('amadeus-refx-manage-booking-url');
        var amadeusParams = (_a = inject('amadeus-params')) !== null && _a !== void 0 ? _a : {};
        var manageParams = (_b = inject('amadeus-manage-params')) !== null && _b !== void 0 ? _b : {};
        var useRefx = computed(function () { return !!refxManageBookingUrl; });
        var params = computed(function () {
            var _a;
            if (refxManageBookingUrl) {
                return {
                    recLoc: bookingNumber.value,
                    lastName: DIRECT_RETRIEVE_LASTNAME.value,
                };
            }
            var params = (_a = {},
                _a[selectedOption.value] = bookingNumber.value,
                _a.DIRECT_RETRIEVE_LASTNAME = DIRECT_RETRIEVE_LASTNAME.value,
                _a.EMBEDDED_TRANSACTION = 'RetrievePNR',
                _a.EXTERNAL_ID = 'BOOKING',
                _a);
            params = __assign(__assign(__assign({}, params), amadeusParams), manageParams);
            return params;
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" Commented out for future use "),
                _createCommentVNode(" <radio-button\r\n      v-if=\"!useRefx\"\r\n      id=\"booking-reference\"\r\n      label=\"Booking reference no.\"\r\n      value=\"REC_LOC\"\r\n      name=\"manage-booking\"\r\n      :checked=\"selectedOption === 'REC_LOC'\"\r\n      @change=\"updateSelectedOption('REC_LOC')\"\r\n    ></radio-button> "),
                _createCommentVNode(" <radio-button\r\n      v-if=\"!useRefx\"\r\n      id=\"e-ticket\"\r\n      label=\"E-ticket no.\"\r\n      value=\"E_TICKET_NUMBER\"\r\n      name=\"manage-booking\"\r\n      :checked=\"selectedOption === 'E_TICKET_NUMBER'\"\r\n      @change=\"updateSelectedOption('E_TICKET_NUMBER')\"\r\n    ></radio-button> "),
                (selectedOption.value === 'REC_LOC' || selectedOption.value === '')
                    ? (_openBlock(), _createBlock(InputField, {
                        key: 0,
                        modelValue: bookingNumber.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((bookingNumber).value = $event); }),
                        name: "REC_LOC",
                        placeholder: "6-character number, e.g. AZ6E7G",
                        "additional-classes": "input-field m-t--16",
                        error: inputErrors.value
                    }, null, 8 /* PROPS */, ["modelValue", "error"]))
                    : (_openBlock(), _createBlock(InputField, {
                        key: 1,
                        modelValue: bookingNumber.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((bookingNumber).value = $event); }),
                        name: "E_TICKET_NUMBER",
                        placeholder: "E-Ticket number, e.g. 706-2304782462",
                        "additional-classes": "input-field m-t--16",
                        error: inputErrors.value
                    }, null, 8 /* PROPS */, ["modelValue", "error"])),
                _createVNode(InputField, {
                    modelValue: DIRECT_RETRIEVE_LASTNAME.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((DIRECT_RETRIEVE_LASTNAME).value = $event); }),
                    name: "DIRECT_RETRIEVE_LASTNAME",
                    placeholder: "Lastname",
                    "additional-classes": "input-field"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(AmadeusFormSubmission, {
                    url: _unref(refxManageBookingUrl),
                    refx: useRefx.value,
                    params: params.value,
                    onSubmit: handleSubmit
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("button", {
                            class: "button button--primary manage-booking__button",
                            type: "submit",
                            disabled: DIRECT_RETRIEVE_LASTNAME.value === '' || bookingNumber.value === ''
                        }, _toDisplayString(__props.buttontext), 9 /* TEXT, PROPS */, _hoisted_2)
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["url", "refx", "params"])
            ]));
        };
    }
});
